module.exports = __webpack_public_path__ + "static/img/icons8-heart-select.6fad59f1.svg";